"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _partial = _interopRequireDefault(require("lodash-es/partial"));

var _noop3 = _interopRequireDefault(require("lodash-es/noop"));

var _isUndefined3 = _interopRequireDefault(require("lodash-es/isUndefined"));

var _isPlainObject2 = _interopRequireDefault(require("lodash-es/isPlainObject"));

var _isEmpty3 = _interopRequireDefault(require("lodash-es/isEmpty"));

var _debounce3 = _interopRequireDefault(require("lodash-es/debounce"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _constants = require("./_constants");

var _actionInput = _interopRequireDefault(require("../action-input"));

var _list = _interopRequireWildcard(require("../list"));

var _popover = _interopRequireDefault(require("../../atoms/_popover"));

var _selectableList = _interopRequireDefault(require("../selectable-list"));

var _text = _interopRequireDefault(require("../../atoms/text"));

var _versions = require("../../_utils/versions");

var _context = require("../../context");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  line-height: ", ";\n  border-bottom: 1px solid ", ";\n  cursor: pointer;\n  color: ", ";\n  background: ", ";\n  &:hover {\n    text-decoration: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  max-height: ", "px;\n  overflow: auto;\n\n  &:focus {\n    outline: none;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var LIST_ITEM_HEIGHT = 50;

var getColors = function getColors(props) {
  return (0, _versions.getColor)(props, 'list');
};

var ListWrapper = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.maxResultsToShow * LIST_ITEM_HEIGHT;
});

var AddWrapper = _list.StyledRow.extend(_templateObject2(), function (props) {
  return (0, _versions.getProperties)(props, 'searchableInput').addAsTextHeight;
}, function (props) {
  return getColors(props).border;
}, function (props) {
  return (0, _versions.getColor)(props, 'searchableInput').addAsTextColor;
}, function (props) {
  return getColors(props).backgroundHover;
}, function (props) {
  return (0, _versions.getProperties)(props, 'searchableInput').underline;
});

var SearchableInput =
/*#__PURE__*/
function (_Component) {
  _inherits(SearchableInput, _Component);

  //eslint-disable-line
  function SearchableInput(props) {
    var _this;

    _classCallCheck(this, SearchableInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SearchableInput).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "componentWillReceiveProps", function (nextProps) {
      if (_this.props.data !== nextProps.data) {
        _this.setState({
          list: nextProps.data
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (_ref) {
      var searchTerm = _ref.target.value;
      var getDataAsync = _this.props.getDataAsync;
      var isAsyncSearch = !(0, _isUndefined3["default"])(getDataAsync);

      _this.setState(function (prevState) {
        return {
          searchTerm: searchTerm,
          hasErrored: false,
          isSearching: isAsyncSearch
        };
      }, isAsyncSearch ? _this.getData : _this.filter);
    });

    _defineProperty(_assertThisInitialized(_this), "onSelect", function (selected) {
      var _this$props = _this.props,
          getDataAsync = _this$props.getDataAsync,
          data = _this$props.data,
          showSelection = _this$props.showSelection,
          _this$props$config = _this$props.config,
          value = _this$props$config.value,
          label = _this$props$config.label;
      var list = _this.state.list;
      var items = !(0, _isUndefined3["default"])(getDataAsync) ? list : data;
      var selection = items.find(function (item) {
        return selected === ((0, _isPlainObject2["default"])(item) ? item[value] : item);
      });

      _this.listWrapper.blur();

      if (showSelection) {
        var labelToshow = (0, _isPlainObject2["default"])(selection) ? selection[label] : selection;

        _this.setState({
          searchTerm: labelToshow
        });
      } else {
        _this.setState({
          list: data,
          searchTerm: ''
        });
      }

      _this.props.onSelection(selection);
    });

    _defineProperty(_assertThisInitialized(_this), "renderItem", function (item) {
      var isObject = (0, _isPlainObject2["default"])(item);
      var _this$props$config2 = _this.props.config,
          label = _this$props$config2.label,
          value = _this$props$config2.value;
      var listValue = isObject ? item[value] : item;

      if (typeof _this.props.renderResult === 'function') {
        return _react["default"].createElement(_selectableList["default"].Item, {
          key: listValue,
          value: listValue
        }, _this.props.renderResult(_this.state.searchTerm, item));
      }

      return _react["default"].createElement(_selectableList["default"].Item, {
        key: listValue,
        value: listValue
      }, isObject ? item[label] : item);
    });

    _defineProperty(_assertThisInitialized(_this), "getErrorMsg", function (type) {
      var messages = _this.props.messages;

      if (type === 'noResults') {
        return messages && messages.noResults || _constants.MSG_NO_RESULTS;
      }

      if (type === 'serverError') {
        return messages && messages.serverError || _constants.MSG_SERVER_ERROR;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderEmptyList", function () {
      return _react["default"].createElement(_list["default"], {
        lean: true
      }, _react["default"].createElement(_text["default"], {
        size: 4
      }, _this.getErrorMsg('noResults')));
    });

    _defineProperty(_assertThisInitialized(_this), "renderErrorList", function () {
      return _react["default"].createElement(_list["default"], {
        lean: true
      }, _react["default"].createElement(_text["default"], {
        size: 4,
        color: 'vermilion'
      }, _this.getErrorMsg('serverError')));
    });

    _defineProperty(_assertThisInitialized(_this), "renderNothing", function () {
      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "renderSearching", function () {
      var messages = _this.props.messages;
      var msg = messages && messages.searching || _constants.MSG_SEARCHING;
      return _react["default"].createElement(_list["default"], {
        lean: true
      }, _react["default"].createElement(_text["default"], {
        size: 4
      }, msg));
    });

    _defineProperty(_assertThisInitialized(_this), "renderListChildren", function () {
      var _this$state = _this.state,
          list = _this$state.list,
          hasErrored = _this$state.hasErrored,
          searchTerm = _this$state.searchTerm,
          isSearching = _this$state.isSearching;
      var isEmptyList = (0, _isEmpty3["default"])(list);
      if (!searchTerm.length && isEmptyList) return _this.renderNothing();
      if (isSearching) return _this.renderSearching();
      if (hasErrored) return _this.renderErrorList();
      if (isEmptyList) return _this.renderEmptyList();
      return _react["default"].createElement(_selectableList["default"], {
        lean: true,
        onSelection: _this.onSelect
      }, list.map(_this.renderItem));
    });

    _defineProperty(_assertThisInitialized(_this), "closeListOnAddEntry", function (callback) {
      var searchTerm = _this.state.searchTerm;
      var showSelection = _this.props.showSelection;
      callback(searchTerm);

      _this.listWrapper.blur();

      if (!showSelection) {
        _this.setState({
          searchTerm: ''
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderAddNewButton", function () {
      var _this$state2 = _this.state,
          searchTerm = _this$state2.searchTerm,
          isSearching = _this$state2.isSearching,
          hasErrored = _this$state2.hasErrored;
      var _this$props2 = _this.props,
          onAddEntry = _this$props2.onAddEntry,
          version = _this$props2.version;
      if (!searchTerm.length || isSearching || hasErrored) return _this.renderNothing();

      if (typeof _this.props.renderAddText === 'function') {
        return _react["default"].createElement(AddWrapper, {
          onClick: (0, _partial["default"])(_this.closeListOnAddEntry, onAddEntry),
          version: version
        }, _this.props.renderAddText(searchTerm));
      }

      return _react["default"].createElement(AddWrapper, {
        onClick: (0, _partial["default"])(_this.closeListOnAddEntry, onAddEntry),
        version: version
      }, "Add '", _react["default"].createElement("strong", null, searchTerm), "' as new");
    });

    _defineProperty(_assertThisInitialized(_this), "renderList", function () {
      var showAddNew = _this.props.showAddNew;
      return _react["default"].createElement(ListWrapper, {
        maxResultsToShow: _this.props.maxResultsToShow,
        tabIndex: '0',
        innerRef: function innerRef(e) {
          return _this.listWrapper = e;
        }
      }, showAddNew && _this.renderAddNewButton(), _this.renderListChildren());
    });

    _defineProperty(_assertThisInitialized(_this), "filter", function () {
      var searchTerm = _this.state.searchTerm;
      var data = _this.props.data;
      var list = data.filter(function (item) {
        var label = _this.props.config.label;
        var val = (0, _isPlainObject2["default"])(item) ? item[label] : item;
        return val.toLowerCase().includes(searchTerm.toLowerCase());
      });

      _this.setState({
        list: list
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getData", (0, _debounce3["default"])(function () {
      var _this$props3 = _this.props,
          getDataAsync = _this$props3.getDataAsync,
          onReject = _this$props3.onReject,
          onResolve = _this$props3.onResolve;
      var searchTerm = _this.state.searchTerm;
      if (!searchTerm.length) return _this.setState({
        list: []
      });
      getDataAsync(searchTerm).then(function (list) {
        return _this.setState({
          list: list,
          isSearching: false
        }, (0, _partial["default"])(onResolve, list));
      })["catch"](function (err) {
        _this.setState({
          hasErrored: true,
          isSearching: false
        }, (0, _partial["default"])(onReject, err));
      });
    }, 200));

    _this.state = {
      searchTerm: '',
      list: props.data,
      hasErrored: false,
      isSearching: false
    };
    _this.INPUT_ACTIONS = [{
      method: _noop3["default"],
      label: '',
      icon: props.searchIcon === 'none' ? '' : props.searchIcon
    }];
    return _this;
  }

  _createClass(SearchableInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props4 = this.props,
          showSelection = _this$props4.showSelection,
          initialValue = _this$props4.initialValue,
          getDataAsync = _this$props4.getDataAsync,
          _this$props4$config = _this$props4.config,
          value = _this$props4$config.value,
          label = _this$props4$config.label;
      /*
      * setting the initial only when the showSelection is true and
      * not making any call to get the results
      */

      if (!getDataAsync && showSelection && initialValue) {
        var list = this.state.list;
        var valueToShow = ''; //* Finding out whether the initial value is available in the list or not

        valueToShow = list.find(function (item) {
          return initialValue === ((0, _isPlainObject2["default"])(item) ? item[value] : item);
        }); //* if initialValue is available then setting that into the state

        if (valueToShow) {
          this.setState({
            searchTerm: (0, _isPlainObject2["default"])(valueToShow) ? valueToShow[label] : valueToShow
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          placeholder = _this$props5.placeholder,
          fullWidth = _this$props5.fullWidth,
          readOnly = _this$props5.readOnly,
          id = _this$props5.id;
      return _react["default"].createElement(_popover["default"], {
        fullWidth: fullWidth,
        content: this.renderList(),
        contentDisabled: readOnly
      }, _react["default"].createElement(_actionInput["default"], {
        "native": true,
        id: id,
        readOnly: readOnly,
        placeholder: placeholder,
        onChange: this.onChange,
        actions: this.INPUT_ACTIONS,
        error: this.state.hasErrored,
        value: this.state.searchTerm
      }));
    }
  }]);

  return SearchableInput;
}(_react.Component);

SearchableInput.propTypes = {
  /** Input placeholder text */
  placeholder: _propTypes["default"].string,

  /** Array of String to search from */
  data: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].string), _propTypes["default"].arrayOf(_propTypes["default"].object)]),

  /** Take full width of parent */
  fullWidth: _propTypes["default"].bool,

  /** Callback on item select */
  onSelection: _propTypes["default"].func,

  /** Config object when the data is array of objects,
   * label should map to the property to be displayed
   * and value should be a unique
   */
  config: _propTypes["default"].shape({
    label: _propTypes["default"].string,
    value: _propTypes["default"].string
  }),

  /** Async function which will be called with the input text,
   * that returns a promise from which the data will be extracted
   */
  getDataAsync: _propTypes["default"].func,

  /** callback that will be called when a getDataAsync promise resolves */
  onResolve: _propTypes["default"].func,

  /** callback that will be called when a getDataAsync promise rejects */
  onReject: _propTypes["default"].func,

  /** Number of results to show */
  maxResultsToShow: _propTypes["default"].number,

  /** Show the selection in the input field */
  showSelection: _propTypes["default"].bool,

  /** search icon name */
  searchIcon: _propTypes["default"].string,
  readOnly: _propTypes["default"].bool,

  /** Initial value given at the time of mounting */
  initialValue: _propTypes["default"].string,
  messages: _propTypes["default"].shape({
    searching: _propTypes["default"].string,
    serverError: _propTypes["default"].string,
    noResults: _propTypes["default"].string
  })
};
SearchableInput.defaultProps = {
  fullWidth: true,
  placeholder: _constants.MSG_SEARCH_TEXT,
  data: [],
  onSelection: _noop3["default"],
  onResolve: _noop3["default"],
  onReject: _noop3["default"],
  config: {
    label: '',
    value: ''
  },
  maxResultsToShow: 5,
  showAddNew: false,
  onAddEntry: _noop3["default"],
  showSelection: false,
  searchIcon: 'search'
};
SearchableInput.displayName = 'SearchableInput';

var _default = (0, _context.withVersion)(SearchableInput);

exports["default"] = _default;